module.exports = __webpack_public_path__ + "img/标题@2x(2).98fee9af.png";